// extracted by mini-css-extract-plugin
export default {"row":"MyTeamsTableRow_row__Vacu9","actions":"MyTeamsTableRow_actions__cKZUe","text":"MyTeamsTableRow_text__friqf","remove":"MyTeamsTableRow_remove__sJhpL"};